import './assets/style/index.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router';
import  './utils/web-app';

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
